import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import { getAllProductsByChannel } from '../product.selectors';
import * as productActions from '../product.actions';
import ProductScoresForm from './ProductScoresForm';
import { Localize } from '../../../locale/localization';

const constraints = {
  numericality: {
    onlyInteger: true,
    message: `^${Localize('form.product-scores.score.error')}`
  }
};

class ProductScoresFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      productScores: [],
    };

    this.state = {
      ...this.state,
      formData,
    };
  }

  componentWillMount = () => {
    const {
      id,
      getProducts,
    } = this.props;

    if(id) {
      getProducts(true).then(() => {
        const { products } = this.props;
        const productScores = products.map(product => {
          const {
            _id,
            productCategory,
            periodInMonths,
            type,
            scoreEarned,
          } = product;

          return {
            productId: _id,
            productCategory,
            periodInMonths,
            type,
            score: scoreEarned,
          };
        });

        const { formData } = this.state;

        this.setState({
          formData: {
            ...formData,
            productScores
          }
        }, this.validate);
      });
    }
  }

  getConstraints = () => constraints;

  validate = () => {
    const formData = this.state.formData;
    const { productScores } = formData;
    const errors = {};
    productScores.forEach(item => {
      const error = validate.single(item.score, constraints);
      if(error) {
        errors[item.productId] = error;
      }
    });

    const isValid = isEmpty(errors);
  
    this.setState({
      errors,
      isValid,
      formData,
    });
  }

  doSubmit = (formData) => {
    const { updateProductScores, cancelPath, history } = this.props;
    updateProductScores(formData).then(() => {
      history.replace(cancelPath);
    });
    //TODO Success & error handling
  };

  onCancel = (event) => {
    event.preventDefault();
    
    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  }

  onInputChange = (event) => {
    const target = event.target;
    const { value, name } = target;

    const { productScores } = this.state.formData;
    
    const updatedProduct = find(productScores, {productId:name});
    const updatedProductIndex = productScores.indexOf(updatedProduct);

    const newProductScores = [
      ...productScores.slice(0, updatedProductIndex),
      {
        ...updatedProduct,
        score: value,
      },
      ...productScores.slice(updatedProductIndex+1),
    ];


    const { formData } = this.state;

    this.setState({
      formData: {
        ...formData,
        productScores: newProductScores,
      }
    }, this.validate);
    
    this.updateTouchedfields(event);
  }

  render() {
    //const products = this.state.productScores;
    return (
      <ProductScoresForm
        enabled={!this.state.isSubmitting}
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
        onInputChange={this.onInputChange}
        onBlur={this.onBlur}
        errors={this.state.errors}
        touchedFields={this.state.touchedFields}
        isValid={this.state.isValid}
        products={this.state.formData.productScores}
      />
    );
  }
}

const mapStateToProps = (state, { match, cancelPath }) => {
  const {
    id
  } = match.params;

  const productsByChannel = getAllProductsByChannel(state);
  const channel = id ? find(productsByChannel, { '_id': id }) : undefined;
  const products = channel && channel.products ? channel.products : [];
  
  //TODO
  return {
    id,
    products,
    cancelPath,
  };
};

const ConnectedProductScoresFormContainer = connect(
  mapStateToProps,
  Object.assign({}, productActions),
)(ProductScoresFormContainer);

export default withRouter(ConnectedProductScoresFormContainer);


// WEBPACK FOOTER //
// ./src/modules/product/components/ProductScoresFormContainer.js